module.exports = __webpack_public_path__ + "static/media/CopyLinkIcon.f0221e6a.svg";